'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseInlineOverlay = require('@bibliocommons/base-inline-overlay');

var _baseAccessibilityTextField = require('@bibliocommons/base-accessibility-text-field');

var _baseAccessibilityTextField2 = _interopRequireDefault(_baseAccessibilityTextField);

var _baseButtons = require('@bibliocommons/base-buttons');

require('../styles/NewSavedSearch.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewSavedSearch = function (_BcReactComponent) {
  _inherits(NewSavedSearch, _BcReactComponent);

  function NewSavedSearch(props) {
    _classCallCheck(this, NewSavedSearch);

    var _this = _possibleConstructorReturn(this, (NewSavedSearch.__proto__ || Object.getPrototypeOf(NewSavedSearch)).call(this, props));

    _this.bindAll('handleSubmit', 'handleChange');
    _this.state = {
      value: _this.props.searchQuery
    };
    return _this;
  }

  _createClass(NewSavedSearch, [{
    key: 'handleChange',
    value: function handleChange(value) {
      this.setState({ value: value });
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      var query = window.location.search;
      this.props.saveSearch(this.state.value, query);
    }
  }, {
    key: 'renderErrorMessage',
    value: function renderErrorMessage() {
      var error = this.props.fieldErrors && this.props.fieldErrors.get('name');
      if (error) {
        return _react2.default.createElement(
          _reactIntl.FormattedMessage,
          { id: 'errors.' + error.get('classification'), defaultMessage: error.get('message') },
          function (message) {
            return _react2.default.createElement(
              'span',
              { className: 'help-block' },
              message
            );
          }
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'form',
        { onSubmit: this.handleSubmit, className: 'form-inline cp-new-saved-search', action: '', role: 'form', method: 'post' },
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('form-group', { 'has-error': this.props.fieldErrors && this.props.fieldErrors.get('name') }) },
          _react2.default.createElement(
            'label',
            { htmlFor: 'search-name', className: 'search-name-label' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'save_search_label' })
          ),
          _react2.default.createElement(_baseAccessibilityTextField2.default, {
            type: 'text',
            id: 'search-name',
            maxLength: 100,
            required: true,
            handleChange: this.handleChange,
            value: this.state.value,
            testId: 'saved-search-name-field',
            errorKey: 'search-name_field',
            className: 'form-control search-name-field' }),
          this.renderErrorMessage()
        ),
        _react2.default.createElement(
          _baseInlineOverlay.InlineOverlayFooter,
          null,
          _react2.default.createElement(
            _baseButtons.PrimaryButton,
            {
              type: 'submit',
              id: 'save_search_save',
              'data-test-id': 'save-search-submit',
              isLoading: this.props.isSaving },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'save_search_save' })
          ),
          _react2.default.createElement(
            _baseInlineOverlay.InlineOverlayCloseButton,
            { className: 'btn btn-default' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_cancel' })
          )
        )
      );
    }
  }]);

  return NewSavedSearch;
}(_baseBcReactComponent2.default);

NewSavedSearch.propTypes = {
  isSaving: _react.PropTypes.bool,
  searchQuery: _react.PropTypes.string,
  saveSearch: _react.PropTypes.func.isRequired
};

exports.default = NewSavedSearch;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/saved-search/lib/components/new-saved-search/components/NewSavedSearch.component.js
// module id = 1465
// module chunks = 1